<template>
  <generic-container
    :title="$t('worklist')"
    icon="task list"
    :show_plus="true"
    :wide="wide"
    :header_buttons="header_buttons"
    @add="create_instance"
  >
    <table class="ui celled very compact selectable striped table" ref="table">
      <thead>
        <tr>
          <th>{{ $t("process") }}</th>
          <th>{{ $t("title") }}</th>
          <th>{{ $t("start date") }}</th>
          <!-- <th>{{ $t("started time") }}</th> -->
          <!-- <th>{{ $t("priority") }}</th> -->
        </tr>
      </thead>
      <tbody></tbody>
    </table>
    <div ref="modals">
      <template v-for="(mdl, index) in start_modals">
        <component
          :is="mdl"
          :key="index"
          @succedded="succedded"
          @destroy="destroyed"
        ></component>
      </template>
      <template v-for="(mdl, index) in tracking_modals">
        <component
          :is="mdl"
          :key="index"
          :instance_id="tracking_instance_id"
          @destroy="destroyed"
        ></component>
      </template>
    </div>
  </generic-container>
</template>

<script>
import GenericContainer from "@/components/GenericContainer";
import "datatables.net";
import "datatables.net-se";
import { error_toast, enterprise_setup } from "@/utils";
import filters from "@/filters";
import StartModal from "./NgineWorkspaceStartModal";
import InstanceTrackingModal from "./NgineInstanceTrackingModal";

export default {
  name: "NgineWorkspaceWorklist",
  components: { GenericContainer },
  data() {
    return {
      datatable: undefined,
      header_buttons: [
        {
          icon: "refresh",
          color: "blue",
          click: this.refresh_worklist,
          tooltip: this.$t("refresh"),
        },
        {
          icon: "arrows alternate horizontal",
          color: "",
          click: this.toggle_wide,
          tooltip: this.$t("toggle size"),
        },
      ],
      user_tasks: [],
      start_modals: [],
      tracking_modals: [],
      tracking_instance_id: "",
      wide: true,
    };
  },
  methods: {
    refresh_worklist() {
      let vm = this;
      let ent_setup = enterprise_setup(vm);
      vm.$emit("refresh");

      if (vm.datatable) vm.datatable.destroy();

      vm.datatable = window.jQuery(vm.$refs.table).DataTable({
        processing: true,
        serverSide: true,
        // info: false,
        ajax: {
          url: window.jQuery.fn.api.settings.api["worklist url"], //"/ngine_workspace/worklist/do-get-list",
          type: "post",
          beforeSend: function (request) {
            let token = vm.$session.get("token");
            if (token) {
              request.setRequestHeader("x-access-token", token);
            }
          },
          dataSrc: function (json) {
            if (!json.success) error_toast(json.error);
            else return json.data;
          },
        },
        columns: [
          {
            data: function (row) {
              return `<a class="track instance" data-u="${row.ngn_interaction.ngn_instance.uuid}">${row.ngn_interaction.ngn_instance.ngn_process.name} <small>${row.ngn_interaction.ngn_instance.ngn_process.ngn_deployment.version}</small></a>`;
            },
          },
          {
            data: function (row) {
              return row.title;
            },
          },
          {
            data: function (row) {
              let formattedDate = filters.formatDate(
                row.create_date,
                ent_setup.detailed_date_format,
              );

              let fromNow = filters.fromNow(row.create_date);
              return `${formattedDate} (${fromNow})`;
            },
          },
          // {
          //   data: function(row) {
          //     let fromNow = filters.fromNow(row.create_date);
          //     return fromNow;
          //   },
          // },
          // {
          //   data: function(row) {
          //     return row.priority;
          //   },
          // },
        ],
        createdRow: function (row, data) {
          window.jQuery(row).click(function () {
            window.jQuery(vm.$refs.table).find("tr").removeClass("warning");
            window.jQuery(this).addClass("warning");
            vm.$emit("select_task", data);
          });
        },
      });
    },
    create_instance() {
      this.start_modals.push(StartModal);
    },
    succedded(/*instance_id*/) {
      this.refresh_worklist();
    },
    destroyed() {
      this.start_modals = [];
      this.tracking_modals = [];
    },
    toggle_wide() {
      this.wide = !this.wide;
    },
  },
  mounted() {
    let vm = this;
    vm.refresh_worklist();

    window.jQuery(document).on("click", "a.track.instance", function () {
      vm.tracking_instance_id = window.jQuery(this).data("u");
      vm.tracking_modals.push(InstanceTrackingModal);
    });
  },
  watch: {},
};
</script>
